const counter = document.querySelectorAll(".count");
if (counter) {
  counter.forEach((item) => {
    const count = item;
    count.counterAlreadyFired = false;
    count.counterSpeed = count.getAttribute("data-counter-time") / 45;
    count.counterTarget = +count.innerText;
    count.counterCount = 0;
    count.counterStep = count.counterTarget / count.counterSpeed;
    count.updateCounter = () => {
      count.counterCount += count.counterStep;
      count.innerText = Math.ceil(count.counterCount);

      if (count.counterCount < count.counterTarget) {
        setTimeout(count.updateCounter, count.counterSpeed);
      } else {
        count.innerText = count.counterTarget;
      }
    };
  });

  // Function to determine if an element is visible in the web page
  const isElementVisible = function isElementVisible(el) {
    const scroll = window.scrollY || window.pageYOffset;
    const boundsTop = el.getBoundingClientRect().top + scroll;
    const viewport = {
      top: scroll,
      bottom: scroll + window.innerHeight,
    };
    const bounds = {
      top: boundsTop,
      bottom: boundsTop + el.clientHeight,
    };
    return (
      (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
      (bounds.top <= viewport.bottom && bounds.top >= viewport.top)
    );
  };

  // Funciton that will get fired uppon scrolling
  const handleScroll = function handleScroll() {
    counter.forEach((item) => {
      const count = item;

      if (count.counterAlreadyFired === true) return;
      if (!isElementVisible(count)) return;
      count.updateCounter();
      count.counterAlreadyFired = true;
    });
  };

  // Fire the function on scroll
  window.addEventListener("scroll", handleScroll);
}
